/**
 * @fileoverview POST handler for the "/apps/engagement_reports/canvases_by_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsEngagementReportsCanvasesByTagsCacheKeys } from "./constants";
import type {
  PostAppsEngagementReportsCanvasesByTagsProps,
  AppsEngagementReportsCanvasesByTagsResult,
} from "./types";

export const postAppsEngagementReportsCanvasesByTags = reactQueryMutationAdapter(
  appsEngagementReportsCanvasesByTagsCacheKeys,
  (props: PostAppsEngagementReportsCanvasesByTagsProps): Promise<AppsEngagementReportsCanvasesByTagsResult> => {
    return fetch("/apps/engagement_reports/canvases_by_tags", "POST", {
      app_group_id: props.appGroupId,
      tags: props.tags,
      tag_selector: props.tagSelector,
    });
  }
);
